import { render, staticRenderFns } from "./ClasificadorLayout.vue?vue&type=template&id=c8e90e9a&scoped=true"
import script from "./ClasificadorLayout.vue?vue&type=script&lang=js"
export * from "./ClasificadorLayout.vue?vue&type=script&lang=js"
import style0 from "./ClasificadorLayout.vue?vue&type=style&index=0&id=c8e90e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e90e9a",
  null
  
)

export default component.exports